import Vue from 'vue';
import { refsService } from '../_services';

export const refs = {
  namespaced: true,
  state: {
    status: 'pending',
    clients: {},
    client_sites: {},
    clients_active: {},
    agencies: {},
    topic_areas: {},
    content_formats: {},
    newItem: {},
  },
  getters: {
    status: state => state.status,
  },
  actions: {
    getAll({ commit }) {
      commit('getAllRequest');
      refsService.getAll().then(
        response => commit('getAllSuccess', response),
        error => commit('getAllFailure', error)
      );
    },
    newItem({ commit }, payload) {
      // debugger
      commit('newItemRequest', payload);
      refsService.newItem(payload).then(
        response => commit('newItemSuccess', response),
        error => commit('newItemFailure', error)
      );
    },
    archiveClient({ commit }, payload) {
      commit('updateStatus', 'pending');
      refsService.archiveClient(payload).then(
        response => {
          commit('archiveClientSuccess', response);
          commit('updateStatus', 'success');
        },
        () => commit('updateStatus', 'error')
      );
    },
    updateItem({ commit }, payload) {
      refsService.updateItem(payload).then(
        response => commit('updateItemSuccess', response)
      );
    },
    updateRefAfterInsert({ commit }, data) {
      commit('updateRefAfterInsert', data);
    },
  },
  mutations: {
    updateStatus(state, status) {
      Vue.set(state, 'status', status);
    },
    getAllRequest(state) {
      state.all = { loading: true };
      state.isDataLoaded = false;
    },
    newItemRequest(state) {
      state.all = { loading: true };
      state.isDataLoaded = false;
    },
    archiveClientSuccess(state, data) {
      state.isDataLoaded = false;
      state.clients = data[1];
      state.clients_active = state.clients.filter(e=>!e.archived);
      state.isDataLoaded = true;
    },
    clearNewRefItem(state) {
      state.newItem = {};
    },
    getAllSuccess(state, data) {
      state.topic_areas = data.topic_areas;
      state.clients = data.clients;
      state.client_sites = data.client_sites;
      state.clients_active = data.clients.filter(e=>!e.archived);
      state.clients_archived = data.clients.filter(e=>e.archived);
      state.agencies = data.agencies;
      state.content_formats = data.content_formats;
      state.isDataLoaded = true;
    },
    newItemSuccess(state, data) {
      state[data[0].refName] = data[1];
      if (data[0].refName==='clients') {
        state.clients_active = state.clients.filter(e=>!e.archived);
        state.clients_archived = state.clients.filter(e=>e.archived);
      }

      state.newItem = data;
      state.isDataLoaded = true;
    },
    updateItemSuccess(state, data) {
      state[data[0].refName] = data[1];
      state.isDataLoaded = true;
    },
    updateRefAfterInsert(state, data) {
      // debugger
      state[data.refId] = data.refData.data[1];
    },
    getAllFailure(state, error) {
      state.all = { error };
    },
  },
};
